// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    recalcPositions();

    if (!_enableAutoLoad) {
        _initialized = false;
        return;
    }

    if (!_initialized) {
         wireScrollEvent();
    }
}

// #endregion Exports

// #region Private members

const _scrollOffset = 200;
let _button: JQuery<Node>;
let _buttonOffset: number;
let _enableAutoLoad: boolean;
let _initialized: boolean;
let _windowHeight: number;

// #endregion Private members

// #region Private functions

function wireScrollEvent() {
    const $window = $(window);
    $window.resize(recalcPositions);
    $window.scroll(onScrollEvent);
    _initialized = true;
}

function recalcPositions() {
    const button = $('.js-autoload-more:visible');
    if (button.length === 0) {
        _enableAutoLoad = false;
        return;
    }

    _button = button;
    _buttonOffset = button.offset().top;
    _windowHeight = $(window).height();
    _enableAutoLoad = true;
}

function onScrollEvent() {
    if (!_enableAutoLoad) {
        return;
    }

    const scrollTop = $(window).scrollTop();

    if (_buttonOffset < (scrollTop + _windowHeight + _scrollOffset)) {
        _button.click();
        _enableAutoLoad = false;
    }
}

// #endregion Private functions